// This function allow to reference async chunks
__webpack_require__.u = (chunkId) => {
	// return url for filenames based on template
	return "static/js/" + chunkId + "." + {"213":"ab593dc7","239":"661639a0","732":"efbc0b03"}[chunkId] + ".chunk.js";
};